import React from "react";
import DivContainerBody from "../../../../../../components/DivContainerBody";
import { IconPersonArrow } from "../../../../../../components/buttons/IconButtons";
import SummaryContainerDetails from "./SummaryContainerDetails";
import SummaryContainerCafeterias from "./SummaryContainerCafeterias";
import SummaryContainerDepartments from "./SummaryContainerDepartments";
import SummaryContainerCustomAccess from "./SummaryContainerCustomAccess";
import SummarySection from "../../../../../../components/Summary/SummarySection";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Final step of the create foodie shift flow. Read-only recap of the shift:
 * details (name), diners, departments and custom access. Mirrors the attendance
 * Summary (titled SummarySection wrapper + per-section SummaryContainer
 * components fed by the local selection lists).
 */
const Summary = ({
                     t,
                     item,
                     cafeterias = [],
                     departments = [],
                     user = [],
                 }) => {

    return (
        <DivContainerBody>
            <SummarySection icon={IconPersonArrow} title={t('schedule')}>
                <SummaryContainerDetails data={item} t={t} />
            </SummarySection>

            <SummaryContainerCafeterias t={t} selected={cafeterias} />

            <SummaryContainerDepartments t={t} selected={departments} />

            <SummaryContainerCustomAccess t={t} selected={user} />
        </DivContainerBody>
    );
};

export default Summary;
